var $23214587b45d0c7a$exports = {};
$23214587b45d0c7a$exports = {
    "loading": `Indl\xe6ser ...`,
    "placeholder": `V\xe6lg\u{2026}`
};


export {$23214587b45d0c7a$exports as default};
//# sourceMappingURL=da-DK.module.js.map
